/**
 * Topology color coding and shared UI components for Flux PhD.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { vortxTypography } from '@vortx/shared-ui';

export const accentColor = '#9b59b6';

/**
 * Map topology ID to a consistent color.
 */
export const getTopologyColor = (id) => {
    if (id === 1) return '#3498db';  // AC-coupled (blue)
    if (id >= 2 && id <= 4) return '#2ecc71';  // DC-coupled (green)
    if (id === 5) return '#f39c12'; // Retrofit (orange)
    if (id === 6) return '#e74c3c'; // Microgrid (red)
    if (id === 7) return '#9b59b6'; // Charger-integrated (purple)
    if (id >= 8 && id <= 10) return '#5fd4c4'; // Fleet/specialized (teal)
    if (id === 11) return '#3498db'; // Charging hub (blue)
    if (id === 12) return '#f39c12'; // Multi-voltage (orange)
    return accentColor;
};

/**
 * Reusable metric row for topology detail displays.
 */
export const MetricRow = ({ label, value, color = '#f4f1ec' }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.75 }}>
        <Typography sx={{
            fontFamily: vortxTypography.mono,
            fontSize: '0.7rem',
            color: '#888',
        }}>
            {label}
        </Typography>
        <Typography sx={{
            fontFamily: vortxTypography.mono,
            fontSize: '0.7rem',
            color,
            fontWeight: 600,
        }}>
            {value}
        </Typography>
    </Box>
);
